var allTimezones = require('./timezones');

angular.module('GorillaBoy.services')
.factory('DateFormatter', ['SessionManager', '$locale', '$filter', '$translate',
    function (SessionManager, $locale, $filter, $translate) {
        var dateFormatter = {},
            timeZones = allTimezones || [],
            DEFAULT_TIME_ZONE = { id: 'America/Los_Angeles', offset: '-8:00' },
            TODAY = 'Today',
            YESTERDAY = 'Yesterday';

        dateFormatter.MILLISECONDS_PER_MINUTE = 60 * 1000;
        dateFormatter.MILLISECONDS_PER_HOUR = 60 * dateFormatter.MILLISECONDS_PER_MINUTE;
        dateFormatter.MILLISECONDS_PER_DAY = 24 * dateFormatter.MILLISECONDS_PER_HOUR;

        function checkTodayOrYesterday(givenDate) {
            var d = new Date(),
                date = new Date(givenDate);
            date.setHours(0,0,0,0);
            d.setHours(0,0,0,0);
            if(date.getTime() === d.getTime()){
                return TODAY;
            }
            d.setDate(d.getDate() - 1);
            if(date.getTime() === d.getTime()){
                return YESTERDAY;
            }
            return null;
        }

        dateFormatter.timezones = function () {
            return timeZones;
        };

        dateFormatter.getCurrentTimeZoneId = function () {
            var timeZoneId = SessionManager.getTimeZoneId();
            if (angular.isDefined(timeZoneId) && timeZoneId !== null) {
                return timeZoneId;
            }
            return DEFAULT_TIME_ZONE.id;
        };

        // Guaranteed to return a non-null value - falls back on default if not found
        dateFormatter.getTimezoneInfo = function (timeZoneId) {
            if (timeZoneId !== null) {
                for (var z in timeZones) {
                    if (timeZones[z].id == timeZoneId) {
                        return timeZones[z];
                    }
                }
            }
            return DEFAULT_TIME_ZONE;
        };

        /*
        dateFormatter.createTimezoneDate = function (date, timeZoneId) {
            if (timeZoneId === null) {
                timeZoneId = dateFormatter.getCurrentTimeZoneId();
            }
            return new timezoneJS.Date(date, timeZoneId);
        };
        */

        dateFormatter.toReadableDate = function (date) {
            var day = checkTodayOrYesterday(date),
                dateString = null;

            if (day === TODAY) {
                dateString = $translate.instant('LIST_VIEW.DATETIME_TODAY_FORMAT', {dateString: $filter('date')(new Date(date), $locale.DATETIME_FORMATS.shortTime)});
            }
            else if (day === YESTERDAY) {
                dateString = $translate.instant('LIST_VIEW.DATETIME_YESTERDAY_FORMAT', {dateString: $filter('date')(new Date(date), $locale.DATETIME_FORMATS.shortTime)});
            }
            else {
                dateString = $filter('date')(new Date(date), $locale.DATETIME_FORMATS.short);
            }
            return dateString;
        };

        dateFormatter.getShortDate = function (date) {
            var month = (date.getMonth() + 1),
            day = date.getDate();
            if (month < 10) {
                month = '0' + month;
            }
            if (day < 10) {
                day = '0' + day;
            }
            return month + '/' + day + '/' + date.getFullYear();
        };

        /*
        // Returns a timezoneJS.Date object with a specific time and timezone
        dateFormatter.parseToTimezoneDate = function (dateString, timeZoneId) {
            if (timeZoneId === null) {
                timeZoneId = dateFormatter.getCurrentTimeZoneId();
            }
            var time = new timezoneJS.Date(Date.parse(dateString));
            // Subtract the UTC offset (in millis) of the JS-detected time zone
            time.setTime(time.getTime() - time.getTimezoneOffset() * dateFormatter.MILLISECONDS_PER_MINUTE);
            // Set the time zone of the timezoneJS.Date object
            time.setTimezone(timeZoneId);
            // Add back the UTC offset (in millis) of the newly set time zone
            time.setTime(time.getTime() + time.getTimezoneOffset() * dateFormatter.MILLISECONDS_PER_MINUTE);

            return time;
        };


        dateFormatter.getTimezoneAbbreviation = function (timeZoneId) {
            var now = new timezoneJS.Date(new Date(), timeZoneId);
            return now.getTimezoneAbbreviation();
        };
        */

        return dateFormatter;
    }]);
